import React from "react";
import ZapierIcon from "../../../assets/icons/zapier.svg";
import { Col } from "reactstrap";

const Zapier = () => {
  return (
    <Col md="6" xxl="3" xl="4">
      <div className="int-col int-col--coming-soon" aria-disabled="true">
        <div className="img">
          <img src={ZapierIcon} alt="Zapier" />
        </div>
        <div className="text">
          <h3>
            Zapier <span className="int-coming-soon-badge">Coming Soon</span>
          </h3>
          <p>
            Automate your workflows with Zapier — connect apps and move data
            effortlessly.
          </p>
        </div>
      </div>
    </Col>
  );
};

export default Zapier;
